import { createFileRoute } from '@tanstack/react-router'
import { ProductionPage } from '@/components/inventory-flow/ProductionPage'

// Kitchen flow (lane C): the Kitchen Manager's landing page. Renders a
// "not switched on" note unless GET /settings carries kitchen_flow=true.
// ?plan=<id> opens that production plan (linked from a catering booking).
// ?tab= picks Today / Events / Requests or a tool; the old tab names (plan,
// mine, request, return, make, count, waste, basics) still work (Batch 4,
// todayLogic.initialView).
export const Route = createFileRoute('/admin/production')({
  validateSearch: (s: Record<string, unknown>): { plan?: string; tab?: string } => ({
    ...(typeof s.plan === 'string' && s.plan ? { plan: s.plan } : {}),
    ...(typeof s.tab === 'string' && s.tab ? { tab: s.tab } : {}),
  }),
  component: ProductionPage,
})
